import { render, staticRenderFns } from "./Quote.vue?vue&type=template&id=762aecf4&scoped=true&"
import script from "./Quote.vue?vue&type=script&lang=js&"
export * from "./Quote.vue?vue&type=script&lang=js&"
import style0 from "./Quote.vue?vue&type=style&index=0&id=762aecf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762aecf4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDivider,VIcon,VImg,VLayout,VTooltip})
